import _ from 'underscore';
import ko from 'knockout';
import Backbone from 'backbone';
import template from '@bingads-webui-campaign-legacy/budgetlandscape/template/budgetLandscapeViewRecommendation.pug';
import { BudgetLandScapeTable, BudgetLandScapeChart } from '@bingads-webui-campaign/recommendation-inline-budget-view';
import { showDismissFeedbackPopupForBudgetLandscape } from '@bingads-webui-campaign-react/recommendation-dismiss-feedback';
import { NAVIGATE_REASON } from '@bingads-webui-campaign-react/recommendation-feedback-modal';
import pageContext from '@bingads-webui-static-legacy/page-context';
import ViewModel from '@bingads-webui-campaign-legacy/budgetlandscape/viewModel/viewModel';
import {
  RECOMMENDATION_TYPES,
  formatLocaledSeasonalEventType,
  ADINSIGHT_LOG_API_NAME,
  RECOMMENDATION_IDS,
  ADINSIGHT_LOG_ACTION_TYPE,
  CHANNEL_TYPES,
  RecommendationService,
  schema,
  TYPE_DESCRIPTION_TABLE,
} from '@bingads-webui-campaign/recommendation-core';
import { levelAtConstant } from '@bingads-webui-campaign/scope-constants';
// eslint-disable-next-line
import _bingads_webui_component_legacy_legacy_router_index from '@bingads-webui-component-legacy/legacy-router/index';
// eslint-disable-next-line
const { legacyRouter } = _bingads_webui_component_legacy_legacy_router_index;
import instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import appConfig from '@bingads-webui-component-legacy/config/index';
import preferencesService from '@bingads-webui-component-legacy/preference/service/index';
import {
  logBudgetLandScapeForSharedBudgetCampaignView,
  logBudgetLandScapeForSharedBudgetCampaignAdoption,
} from '@bingads-webui-campaign-legacy/budget/shared/log';

const activity = instrumentation.campaignTab.create().budgetLandscape.create();
const Permissions = appConfig.get('Permissions');
const context = {
  Level: levelAtConstant.ACCOUNT,
  CampaignIds: [],
  AdGroupIds: [],
};
const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/budgetlandscape');
const i18nRecommendation = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/competition-tab');
const preferenceName = 'WebApp.CampaignUI.BudgetLandscape.DataVersionFeedback';

export class BudgetLandscapeView extends Backbone.View {
  initialize(options) {
    this.viewModel = new ViewModel();
    this.options = options || {};
    this.opportunityData = options.data;
    this.i18n = i18n;
    this.el = this.options.el;
    this.parentItem = this.options.parentItem || {};
    this.seasonalEvents = this.opportunityData.SeasonalEvents || [];
    this.campaignId = options.campaignId;
    this.dataVersion = this.opportunityData.Version;
    this.opportunityId = options.opportunityId;
    this.appConfig = appConfig;
    this.isForVNext = options.isForVNext;
    this.isInProductFeedbackLoopOn = Permissions && Permissions.IsRecommendationInProductFeedbackLoopEnabled && this.isForVNext;
    this.navigateToType = null;

    if (this.isInProductFeedbackLoopOn) {
      const preference = preferencesService.findByName(preferenceName) || {};

      this.preferenceData = preference.Data || {};
      this.generateScope();
      this.initializeInstrumentation();
      this.dataService = new RecommendationService({
        scope: this.scope,
        currentScenario: this.currentScenario,
        currentActivity: this.currentActivity,
        odataPath: appConfig.get('adinsight.odata.url'),
        permissions: Permissions,
        lcid: pageContext.CultureLcid,
        ccJsData: null,
        isNoExpand: true,
      });

      if (this.preferenceData[this.campaignId] === this.dataVersion) {
        this.viewModel.feedbackComment(i18n.get('Budget_Landscape_Feedback_Thanks'));
        this.viewModel.isThumbVisible(false);
      }
    }

    const isForecasting = this.opportunityData.IsForecasting || false;

    this.showForecastingMessage = isForecasting && this.options.campaignOutOfBudget;
    if (this.options.data.IsShared) {
      this.budgetTitle = i18n.get('Details_View_Increase_Shared_Budget').replace('{{entity_name}}', this.opportunityData.Shared.BudgetName);
    } else {
      this.budgetTitle = i18n.get('BudgetLandscape_Title').replace('{0}', _.result(this.parentItem, 'CampaignName') || '');
    }

    const conversionSummaryStatus = this.opportunityData.ConversionStatus || 0;

    this.tableView = new BudgetLandScapeTable({
      i18n: i18nRecommendation,
      conversionSummaryStatus,
      opportunityData: this.opportunityData,
      appConfig: options.appConfig,
      fromCampaignTab: true,
      currentBudget: options.currentBudget,
      isSharedBudget: this.options.data.IsShared,
      permissions: Permissions,
    });
    this.chartView = new BudgetLandScapeChart({
      tableViewmodel: this.tableView.getViewModel(),
      i18n: i18nRecommendation,
      conversionSummaryStatus,
      legacyRouter: options.legacyRouter,
    });
    this.tableView.on('selectedRowChanged selectedColumnChanged estimationChanged', () => {
      this.chartView.redraw();
    });
    this.chartView.on('close_poputil', () => {
      this.onCancel();
    });
    const hasData = !_.isEmpty(this.tableView.getViewModel().rawLandscapeData);
    const notExceed = !this.opportunityData.currentLargerThanMax;

    this.showData = hasData && notExceed;

    if (this.options.campaignOutOfBudget) {
      this.helpText = i18n.get('BudgetLandscape_HelpText_OutofBudget');
    } else if (this.seasonalEvents.length > 0) {
      const name = formatLocaledSeasonalEventType(this.i18n, _.first(this.seasonalEvents).Name);

      this.helpText = (isForecasting ? i18n.get('BudgetLandscape_HelpText_Forecasting_Seasonal_Strong') : i18n.get('BudgetLandscape_HelpText_Recovery_Seasonal_Strong')).replace('{0}', name);
    } else {
      this.helpText = isForecasting ? i18n.get('BudgetLandscape_HelpText_Forecasting_Non_Seasonal') : i18n.get('BudgetLandscape_HelpText_Recovery_Non_Seasonal');
    }

    // this.options.data.Shared.BudgetId
    if (this.options.data.IsShared) {
      logBudgetLandScapeForSharedBudgetCampaignView(
        this.options.data.Shared.BudgetId,
        'bingadsweb[incontextrecommendation]',
        this.opportunityId,
        _.result(_.find(this.opportunityData.Landscapes, (i) => i.Comment === 'Suggested'), 'EstimatedBudget'),
        i18nRecommendation.currency,
        activity
      );
    } else {
      this.logAdInsight(ADINSIGHT_LOG_ACTION_TYPE.VIEW);
      this.logAdInsight(ADINSIGHT_LOG_ACTION_TYPE.IMPRESSION);
    }
  }

  generateScope() {
    const campaignId = this.campaignId;

    this.scope = {
      customerId: _.result(this.parentItem, 'CustomerId') || '0',
      accountId: _.result(this.parentItem, 'AcctId') || '0',
      campaignId,
      campaignName: _.result(appConfig.get('CurrentCampaign'), 'Name'),
      token: appConfig.get('Token'),
      levelAt: levelAtConstant.CAMPAIGN,
      entityIds: [campaignId],
    };
  }

  initializeInstrumentation() {
    instrumentation.addScenario(schema);
    this.currentScenario = instrumentation.loadRecommendationTab.create();
    this.currentActivity = this.currentScenario.loadRecommendationTab.create();
  }

  logUserFeedback(formattedReason, isLike = false) {
    const type = RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY;

    activity.trace({
      type,
      action: ADINSIGHT_LOG_ACTION_TYPE.FEEDBACK,
      campaignId: this.campaignId,
      input: {
        isLike,
        formattedReason: _.isNull(formattedReason) ? null : {
          reason: JSON.parse(formattedReason.reason),
        },
      },
      context: _.extend(context, { opportunityId: this.opportunityId }),
    });
  }

  logAdInsight(action) {
    const type = RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY;
    // now budget landscape could only show in campaign tab
    // so, level can only by account

    activity.trace({
      id: this.opportunityId,
      type,
      typeId: RECOMMENDATION_IDS[type],
      action,
      campaignId: this.campaignId,
      channel: CHANNEL_TYPES.INCONTEXT,
      context: JSON.stringify(context),
    }, ADINSIGHT_LOG_API_NAME.RECOMMENDATION);
  }

  get events() {
    return {
      'click  .apply': 'onApply',
      'click  #budget-landscape-cancel': 'onCancel',
      'click  #budget-landscape-close-image': 'onCancel',
      'click  .more-suggestion': 'onCancel',
      'click .more-recommendation a': this.gotoRecommendationTab,
      'click .budget-landscape-dislike': this.handleFeedbackDislike,
      'click .budget-landscape-like': this.handleFeedbackLike,
      'click .navigate-to-recommended-page-link': this.gotoCustomizedRecommendationTab,
    };
  }

  onSubmitFeedback(formattedReason, reasonId) {
    this.logUserFeedback(formattedReason);

    switch (reasonId) {
    case NAVIGATE_REASON.NoBudget: // navigate to different recommendation detail page for certain reason
      this.navigateToType = RECOMMENDATION_TYPES.REALLOCATE_BUDGET;
      break;
    default:
      break;
    }

    if (this.navigateToType) {
      this.dataService.getSummary({
        channel: CHANNEL_TYPES.RECOMMENDATION,
        ignoreCoupons: true,
        type: this.navigateToRoute,
      }).then((opt) => {
        this.oppo = opt.data.value;
        const recommendationTypeAvailable = _.map(this.oppo, (ele) => {
          return ele.OpportunityType;
        });

        if (recommendationTypeAvailable.includes(this.navigateToType)) {
          this.viewModel.feedbackComment(i18n.get('Budget_Landscape_Feedback_SuggestRecommendation', { recommendationDescription: TYPE_DESCRIPTION_TABLE[this.navigateToType] }));
          this.viewModel.isRecommendedPageLinkVisible(true);
        }
      });
    }
  }

  saveDataVersionPreference() {
    preferencesService.set({
      Name: preferenceName,
      Data: _.extend(this.preferenceData, {
        [this.campaignId]: this.dataVersion,
      }),
    });
  }

  handleFeedbackDislike() {
    this.viewModel.feedbackComment(i18n.get('Budget_Landscape_Feedback_Thanks'));
    showDismissFeedbackPopupForBudgetLandscape({
      i18n: i18nRecommendation,
      permissions: Permissions,
      onSubmit: (formattedReason, reasonId) => this.onSubmitFeedback(formattedReason, reasonId),
      isForVNext: this.isForVNext,
      el: '.popup-container .budget-landscape-container-outer',
    });
    this.logUserFeedback(null, false);
    this.saveDataVersionPreference();
  }

  handleFeedbackLike() {
    this.logUserFeedback(null, true);
    this.saveDataVersionPreference();
  }

  prepareView() {
    this.$el.append(
      template({
        Id: this.parentItem.Id,
        CustomerId: _.result(this.parentItem, 'CustomerId') || '0',
        AcctId: _.result(this.parentItem, 'AcctId') || '0',
        BudgetTypeString: this.parentItem.IsDailyBudgt ? i18n.get('BudgetLimitType_Daily') : i18n.get('BudgetLimitType_Monthly'),
        hasEvent: this.seasonalEvents.length > 0,
        showData: this.showData,
        i18n: this.i18n,
        helpId: _.result(this.options, 'helpId') || '',
        helpText: this.helpText,
        isForward: this.showForecastingMessage,
        budgetTitle: this.budgetTitle,
        isInProductFeedbackLoopOn: this.isInProductFeedbackLoopOn,
      })
    );
  }

  render() {
    this.prepareView();
    this.$('.landscape-table').html(this.tableView.render().el);
    this.$('.landscape-chart').html(this.chartView.render().el);

    if (this.showData) {
      ko.applyBindings(this.tableView.getViewModel(), this.$('.budget-landscape-actions')[0]);
    }
    if (this.isInProductFeedbackLoopOn) {
      ko.applyBindings(this.viewModel, this.$('.budget-landscape-feedback-actions')[0]);
    }
    return this;
  }

  onApply() {
    if (this.tableView.isValid()) {
      const newBudget = this.tableView.getSelectedNewBudget();

      if (this.options.data.IsShared) {
        logBudgetLandScapeForSharedBudgetCampaignAdoption(
          this.options.data.Shared.BudgetId,
          'bingadsweb[incontextrecommendation]',
          this.opportunityId,
          _.result(_.find(this.opportunityData.Landscapes, (i) => i.Comment === 'Suggested'), 'EstimatedBudget'),
          newBudget,
          i18nRecommendation.currency,
          activity
        );
      }

      this.trigger('apply', { newBudget });
    }
  }

  onCancel() {
    this.trigger('cancel');
  }

  close() {
    this.remove();
  }

  remove() {
    this.chartView.remove();
    this.tableView.remove();
    super.remove();
  }

  gotoRecommendationTab(e) {
    e.preventDefault();
    this.appConfig.set('recsrc', CHANNEL_TYPES.INCONTEXT);

    legacyRouter.navigateToRoute('campaign_recommendation_details', {
      type: RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY,
      'campaign_id': this.campaignId,
    });
  }

  gotoCustomizedRecommendationTab() {
    this.onCancel();
    legacyRouter.navigateToRoute('campaign_recommendation_details', {
      type: this.navigateToType,
      'campaign_id': this.campaignId,
    });
  }
}
